<template>
  <SiruiSearch
    ref="baseInfoFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    @changeMethod="changeMethod"
    :isDisabledForm="isDisabledForm"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules } from './index.js';
  export default {
    name: 'BaseInfoForm',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      // 网络获取数据反填
      fetchData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        baseFormData: {
          contractNo: '',
          contractStatus: '',
          parkCompanyName: '',
          parkCompanyNo: '',
          parkDepartmentName: '',
          parkDepartmentNo: '',
          operatorName: '',
          operaterNo: '',
          contractType: '',
          signDate: '',
          signPlace: '',
          signPerson: '',
          leaseArea: '',
          leaseDateFrom: '',
          leaseDateUnit: '',
          leaseTerm: '',
          storageName: '',
          storageAddress: '',
          contractPayMethod: '',
          partnerName: '',
          partnerCode: '',
          depositBank: '',
          bankAccount: '',
          absentInterestRate: '',
          paperContractNo: '',
          contractAmount: '',
          remark: '',
        },
        isDisabledForm: false,
        contractPayMethodList: [], //收款方式
        contractTypeList: [], // 合同类型
        contractStatusList: [], // 合同状态
        isRenewStatus: false, //是否续签状态
        disabledList: [], // 禁用字段
      };
    },
    computed: {
      formColumn() {
        return baseFormColumn(this);
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    mounted() {
      this.contractNatureList = this.dictListMap?.SuperviseContractNature || [];
      this.contractPayMethodList = this.dictListMap?.apply_payment_method || [];
      this.contractTypeList = this.dictListMap?.SuperviseContractType || [];
      this.contractStatusList = this.dictListMap?.SuperviseContractStatusType || [];
    },
    methods: {
      changeMethod({ val, prop }) {
        console.log(val, prop);
        const selectRowData = val[0];
        if (prop == 'depositBank') {
          this.baseFormData.depositBank = selectRowData.branchName;
          this.baseFormData.bankAccount = selectRowData.unionKey;
        } else if (prop == 'partnerName') {
          this.baseFormData.partnerName = selectRowData.partnerZhName;
          this.baseFormData.partnerCode = selectRowData.partnerCode;
        }
      },
      async getValidateFormData() {
        const formData = await this.$refs.baseInfoFormRef.getValidateFormData();
        const currentStatus = this.$route.query.status;
        return {
          ...formData,
          // 几个额外字段
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          adminFlag: this.userInfo.adminFlag,
          // 特殊处理id
          id:
            ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
              ? ''
              : formData?.id,
        };
      },
      initData() {
        console.log('初始化数据');
        this.baseFormData = {
          operatorName: this.userInfo.userName,
          operaterNo: this.userInfo.userCode,
          parkDepartmentName: this.userInfo.departmentName,
          parkDepartmentNo: this.userInfo.departmentCode,
          parkCompanyName: this.userInfo.companyName,
          parkCompanyNo: this.userInfo.companyCode,
          contractType: '外部仓库租赁合同',
        };
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          if (['02', '03', '05', '06'].includes(val)) {
            // 如果当前是续签的时候只有主体不可以编辑就是
            const currentStatus = this.$route.query.status;
            if (['renew', 'change'].includes(currentStatus)) {
              this.isRenewStatus = true;
              this.disabledList = ['partnerName'];
            } else if (['create'].includes(currentStatus)) {
              this.isDisabledForm = false;
            } else {
              this.isDisabledForm = true;
            }
            // -1表示弹框
          } else if (['-1'].includes(val)) {
            this.isDisabledForm = true;
          } else {
            this.isDisabledForm = false;
          }
        },
        immediate: true,
      },
      fetchData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            let newObj = {};
            const currentStatus = this.$route.query.status;
            for (const key in val) {
              if (typeof val[key] == 'number') {
                newObj[key] = val[key] + '';
              } else {
                newObj[key] = val[key];
              }
            }
            this.baseFormData = {
              ...newObj,
              // 单独处理下复制时候合同号和状态
              contractNo:
                ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                  ? ''
                  : newObj?.contractNo,
              contractStatus:
                ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                  ? ''
                  : newObj?.contractStatus,
            };
          } else {
            this.initData();
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
